import { ProveedorReferenceCode } from "./ProveedorReferenceCode";
import { ProveedorTagXML } from "./ProveedorTagXML";

export class ProveedorRulesRequest {
   proveedorId: string;
   emisorId: string;
   references: ProveedorReferenceCode[];
   tagsXml: ProveedorTagXML[];
}
